import { CalendarEventType, EventCalendar } from '@/types/Calendar.ts'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { ClosingDay } from '@/types/ClosingDays.ts'
import { EventDay } from '@/types/EventDay.ts'
import { TableCell } from '@mui/material'
import styles from './staffEventsDayCell.module.scss'

interface StaffEventsDayCellProps {
    events: EventCalendar[]
    isOpen: boolean
    columnWidth: string
}

const StaffEventsDayCell: FunctionComponent<StaffEventsDayCellProps> = ({
    events,
    isOpen,
    columnWidth
}: StaffEventsDayCellProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    if (!isOpen) return null

    function defineUrl(event: EventCalendar): string {
        if (event.type === CalendarEventType.CLOSING_DAY) {
            const closingDaySlot: ClosingDay = event.slots as ClosingDay
            return `/events?closingDay=${closingDaySlot.id}&fromDate=${closingDaySlot.startDate}&toDate=${closingDaySlot.endDate}`
        }
        if (event.type === CalendarEventType.EVENT) {
            const eventSlot: EventDay = event.slots as EventDay
            return `/events?event=${eventSlot.id}&fromDate=${eventSlot.date}&toDate=${eventSlot.date}`
        }
        return ''
    }

    return (
        <>
            <TableCell align='center' sx={{ width: columnWidth }}>
                <div className={styles.WorkCell}>
                    {events.length !== 0 &&
                        events.map((event: EventCalendar, index: number) => (
                            <a
                                key={index}
                                className={event.type === CalendarEventType.EVENT ? styles.Event : styles.ClosingDay}
                                onClick={() => navigate(defineUrl(event))}
                            >
                                <span className={styles.Title}>{event.title}</span>
                                {event.number === 'R' && (
                                    <span className={styles.Subtitle}>{t('bookingRequired')}</span>
                                )}
                            </a>
                        ))}
                </div>
            </TableCell>
        </>
    )
}

export default StaffEventsDayCell
